import {
  Flex,
  // @ts-ignore
  IconButton,
  IconChevronDown,
  IconChevronUp,
  Text,
  VisuallyHidden,
} from '@zillow/constellation';
import React, { useCallback, useEffect, useState } from 'react';

interface QuestionAnswerProps {
  question: string;
  answer: string;
  i: number;
  isMobile: boolean;
}

const QuestionAnswer: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<QuestionAnswerProps>>> = (
  props,
) => {
  const { question, answer, i, isMobile } = props;
  const [expanded, setExpanded] = useState(!isMobile);
  useEffect(() => {
    setExpanded(!isMobile);
  }, [isMobile]);
  const expand = useCallback(() => setExpanded(!expanded), [expanded]);
  return isMobile ? (
    <>
      <Flex display="flex" alignItems="baseline">
        <Text as="p" fontType="bodyHeading" marginBottom="sm" style={{ width: '80%' }}>
          {i + 1}. {question}
        </Text>
        <IconButton
          icon={expanded ? <IconChevronUp /> : <IconChevronDown />}
          title={expanded ? 'Collapse' : 'Expand'}
          size="sm"
          onClick={expand}
          style={{ width: '20%', borderWidth: 0 }}
        />
      </Flex>
      {expanded ? (
        <Text as="p" fontColor="textMedium" marginBottom="lg" dangerouslySetInnerHTML={{ __html: answer }} />
      ) : (
        <VisuallyHidden
          // @ts-ignore
          dangerouslySetInnerHTML={{ __html: answer }}
        />
      )}
    </>
  ) : (
    <>
      <Text as="p" fontType="bodyHeading" marginBottom="sm">
        {i + 1}. {question}
      </Text>
      <Text as="p" fontColor="textMedium" marginBottom="lg" dangerouslySetInnerHTML={{ __html: answer }} />
    </>
  );
};

export default QuestionAnswer;
